import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import api from '../../api/endpoints';
import { handleErrors, fetch } from '../../api';

function* getAccount({ payload: { signal } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.profile.details,
      signal
    });

    yield put(actions.getAccountDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getAccountFailed,
      handledErrors: ['detail'],
      endpoint: api.profile.details.url
    });
  }
}

export const getAccountSaga = takeEvery(types.GET_ACCOUNT_REQUEST, getAccount);